import { render } from "./MenuSocials.vue?vue&type=template&id=8ee5f182&scoped=true"
import script from "./MenuSocials.vue?vue&type=script&lang=js"
export * from "./MenuSocials.vue?vue&type=script&lang=js"

import "./MenuSocials.vue?vue&type=style&index=0&id=8ee5f182&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ee5f182"]])

export default __exports__